//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.BaseSymbolBuilder.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[0,"Color",1,0],[0,"Extension",1,0],[1,"Inherit",0,"SelectNXObject",0],[1,"IntersectionObject1",0,"SelectNXObject",0],[1,"IntersectionObject2",0,"SelectNXObject",0],[0,"Width",1,0]],[],[]];
SPLM.Annotations.IntersectionSymbolBuilder = class extends SPLM.Annotations.BaseSymbolBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.IntersectionSymbolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.IntersectionSymbolBuilder.Thickness = Object.freeze({
    "Thin" : "Thin", "Normal" : "Normal", "Thick" : "Thick", "One" : "One", "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five", "Six" : "Six", "Seven" : "Seven", "Eight" : "Eight", "Nine" : "Nine"});

export default SPLM;